import { useReactiveVar } from "@apollo/client";
import { localRecordingToolMenuAnchorVar } from "../../../../model";

type UseRecordingToolMenuAnchor = {
    setRecordingToolMenuAnchor: (anchor: (HTMLElement | null)) => void,
    recordingToolMenuAnchor: HTMLElement
}

export const useRecordingToolMenuAnchor = (): UseRecordingToolMenuAnchor => {
    const recordingToolMenuAnchor = useReactiveVar(localRecordingToolMenuAnchorVar);

    const setRecordingToolMenuAnchor = (anchor: HTMLElement | null) => {
        localRecordingToolMenuAnchorVar(anchor);
    };

    return {
        recordingToolMenuAnchor,
        setRecordingToolMenuAnchor
    };
};
